import { useContext, useMemo } from 'react';
import { UserContext } from '../../contexts';
import { hrefOf, useTransactionsLink } from '../../navigation/transactionsLink';
import { ROUTES } from '../../routes';

export const useNavItems = () => {
  const { isTokenTaxAdmin } = useContext(UserContext);
  const buildLink = useTransactionsLink();
  // While the user loads, link to the legacy explorer; TransactionsExplorerRoute redirects once the model resolves
  const transactionsPath = hrefOf(buildLink({ kind: 'all' })) ?? ROUTES.allTransactions;

  return useMemo(
    () => ({
      taxDashboard: { name: 'Tax Dashboard', path: '/dashboard' },
      holdings: { name: 'Holdings', path: ROUTES.holdings, matchPaths: [/^\/holdings(?:\/|$)/] },
      incomeDashboard: { name: 'Income', path: '/income', shown: isTokenTaxAdmin },
      taxGuide: { name: 'Tax Guide', path: '/tax-guide', shown: isTokenTaxAdmin },
      documents: { name: 'Documents', path: ROUTES.documents, matchPaths: [/^\/documents.*/] },
      documentsTable: { name: 'Documents', path: ROUTES.documentsTable },
      allTransactions: { name: 'Transactions', path: transactionsPath },
      imports: {
        name: 'Imports',
        path: ROUTES.imports,
        matchPaths: [/^\/imports(?:\/|$)/],
      },
      profile: { name: 'Profile', path: '/profile' },
      accountSettings: { name: 'Settings', path: '/settings/profile' },
      upgrade: { name: 'Upgrade', path: ROUTES.upgrade },
      admin: { name: 'Account Admin', path: '/tokentax-admin' },
      recon: { name: 'Recon', path: '/recon', matchPaths: [/^\/recon.*/] },
      csvsInReview: {
        name: 'CSV Review',
        path: '/tokentax-admin/csvs-in-review',
        shown: isTokenTaxAdmin,
      },
      apiErrors: {
        name: 'API Errors',
        path: '/tokentax-admin/api-errors',
        shown: isTokenTaxAdmin,
      },
      scripts: {
        name: 'Scripts',
        path: '/tokentax-admin/scripts',
        shown: isTokenTaxAdmin,
      },
      trello: {
        name: 'Trello',
        path: '/tokentax-admin/trello',
        shown: isTokenTaxAdmin,
      },
    }),
    [isTokenTaxAdmin, transactionsPath],
  );
};
